"use client"
import React from "react"
import { ArticleSlider } from "./article-slider"
import { Button } from "../../../../components/ui/button"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import { posts } from "../../../../data/postsData/postIndex"

const FeaturedArticles = () => {
  const displayedPosts = [posts[21], posts[0], posts[1]]
  return (
    <div className="container min-h-screen flex flex-col justify-center items-center">
      <div className="flex items-center justify-between w-full flex-wrap">
        <h2 className="md:text-[42px] text-[30px] text-black font-bold">
          Featured Articles
        </h2>
        <Button variant="link" size="lg" asChild>
          <Link to="/blogs">See All Posts</Link>
        </Button>
      </div>

      <div className="hidden lg:grid grid-cols-3 pt-4 gap-8">
        {displayedPosts
          .filter((post) => post && post.metadata)
          .map((post, index) => (
            <Link
              key={index}
              to={`/blog/${post.metadata.urlSlug}`}
              className="block"
            >
              <motion.div
                className="bg-white border border-gray-100 shadow-xl hover:shadow-2xl transition-all duration-300 rounded-[10px] overflow-hidden flex flex-col cursor-pointer"
                whileHover={{ y: -4 }}
              >
                <img
                  src={post.metadata.previewImg}
                  alt={`post ${index + 1}`}
                  className="w-full object-cover aspect-video"
                />

                <div className="flex flex-col gap-4 p-6 items-start flex-1">
                  <div
                    className="font-bold text-xl leading-snug"
                    dangerouslySetInnerHTML={{ __html: post.metadata.title }}
                  />

                  <p className="text-sm text-gray-700 flex-1">
                    {post.metadata.description}
                  </p>

                  <span className="text-blurple text-sm font-medium">
                    Read More →
                  </span>
                </div>
              </motion.div>
            </Link>
          ))}
      </div>

      <ArticleSlider posts={displayedPosts} />
    </div>
  )
}

export default FeaturedArticles
